export default "__VITE_ASSET__iDkDlgaO__"